import React from 'react';
import { Badge, Text } from '@mantine/core';

// Vocabulary tags of an art, grouped by dimension, one color per dimension.
// Tags come from the backend as { dimension: [{ value, ru }] } (art.artTags);
// ru is the Russian wording, shown when the UI language is Russian.
export const DIMENSIONS = [
  { key: 'genre',     color: 'blue',   ru: 'Жанр',       en: 'Genre' },
  { key: 'subgenre',  color: 'indigo', ru: 'Поджанр',    en: 'Subgenre' },
  { key: 'motifs',    color: 'grape',  ru: 'Мотивы',     en: 'Motifs' },
  { key: 'tone',      color: 'pink',   ru: 'Тон',        en: 'Tone' },
  { key: 'structure', color: 'teal',   ru: 'Структура',  en: 'Structure' },
  { key: 'setting',   color: 'green',  ru: 'Место',      en: 'Setting' },
  { key: 'hero',      color: 'orange', ru: 'Герой',      en: 'Hero' },
  { key: 'format',    color: 'gray',   ru: 'Формат',     en: 'Format' },
  { key: 'origin',    color: 'cyan',   ru: 'Страна',     en: 'Origin' },
  { key: 'audience',  color: 'lime',   ru: 'Аудитория',  en: 'Audience' },
  { key: 'style',     color: 'violet', ru: 'Стиль',      en: 'Style' },
  { key: 'register',  color: 'dark',   ru: 'Ниша',       en: 'Register' },
];

// People features used by the top-todos ranker alongside vocabulary tags.
export const DIMENSION_COLORS = Object.fromEntries(DIMENSIONS.map(d => [d.key, d.color]));
DIMENSION_COLORS.creator = 'red';
DIMENSION_COLORS.actor = 'yellow';
DIMENSION_COLORS.era = 'gray';

const ArtTags = ({ tags, language = 'ru' }) => {
  if (!tags) return null;
  const groups = DIMENSIONS.filter(d => (tags[d.key] || []).length > 0);
  if (groups.length === 0) return null;
  return (
    <div className="mx-auto w-full max-w-3xl mt-3 flex flex-col items-center gap-1">
      {groups.map(d => (
        <div key={d.key} className="flex flex-wrap items-center justify-center gap-1">
          <Text size="xs" c="dimmed" className="mr-1">{language === 'ru' ? d.ru : d.en}:</Text>
          {tags[d.key].map(t => (
            <Badge key={t.value} color={d.color} variant="light" size="sm" radius="sm" style={{ textTransform: 'none' }}>
              {language === 'ru' && t.ru ? t.ru : t.value}
            </Badge>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ArtTags;
